export default __webpack_public_path__ + "static/media/section3-pic6-h5.283b8f6f.png";